var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        { staticClass: "soli-round", staticStyle: { overflow: "hidden" } },
        [
          _c(
            "v-overlay",
            {
              attrs: {
                value: _vm.calendarLoading,
                "z-index": "12",
                opacity: "100",
                absolute: "",
                color: "white",
              },
            },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64", color: "primary" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-toolbar",
            { class: ["schedule-toolbar"], attrs: { flat: "" } },
            [
              _c(
                "v-row",
                {
                  staticClass: "align-center justify-around",
                  staticStyle: { height: "72px" },
                },
                [
                  _c(
                    "v-col",
                    { staticClass: "flex justify-start", attrs: { cols: "4" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled:
                              _vm.getTitleDate <=
                              _vm.globalMomentYMD(new Date(_vm.calendarMin)),
                            small: _vm.$vuetify.breakpoint.smAndDown,
                            icon: "",
                            elevation: _vm.$vuetify.breakpoint.smAndDown
                              ? 2
                              : 0,
                          },
                          on: { click: _vm.prev },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("chevron_left"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-1",
                          attrs: {
                            disabled: _vm.checkCalendarMax,
                            small: _vm.$vuetify.breakpoint.smAndDown,
                            icon: "",
                            elevation: _vm.$vuetify.breakpoint.smAndDown
                              ? 2
                              : 0,
                          },
                          on: { click: _vm.next },
                        },
                        [
                          _c("v-icon", { attrs: { color: "dark" } }, [
                            _vm._v("chevron_right"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "flex justify-center",
                      attrs: { cols: "4" },
                    },
                    [
                      _c("div", { staticClass: "font-bold px-0 soli-grey" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.getViewTitle) +
                            "\n                    "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass: "justify-end flex",
                      class: _vm.$vuetify.breakpoint.smAndDown ? "my-2" : null,
                      attrs: { cols: "4" },
                    },
                    [
                      _vm.$page.props.auth.user
                        ? _c(
                            "v-btn",
                            {
                              class: [
                                "stack-btn",
                                _vm.$vuetify.breakpoint.smAndDown
                                  ? "mr-1"
                                  : "mr-3",
                              ],
                              attrs: {
                                small: _vm.$vuetify.breakpoint.smAndDown,
                                elevation: _vm.$vuetify.breakpoint.smAndDown
                                  ? 2
                                  : 0,
                                icon: "",
                                ripple: false,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  ;[
                                    (_vm.nearMe = !_vm.nearMe),
                                    _vm.getCalendarEvents(),
                                  ]
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.nearMe ? "secondary" : "dark",
                                  },
                                },
                                [_vm._v("near_me")]
                              ),
                              _vm.$vuetify.breakpoint.smAndUp
                                ? _c(
                                    "small",
                                    {
                                      staticClass: "soli-grey",
                                      staticStyle: { "font-size": "8px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Near Me\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "stack-btn",
                          attrs: {
                            color: "dark",
                            icon: "",
                            small: _vm.$vuetify.breakpoint.smAndDown,
                            elevation: _vm.$vuetify.breakpoint.smAndDown
                              ? 2
                              : 0,
                            ripple: false,
                          },
                          on: { click: _vm.setToday },
                        },
                        [
                          _c("v-icon", [_vm._v("today")]),
                          _vm.$vuetify.breakpoint.smAndUp
                            ? _c(
                                "small",
                                { staticStyle: { "font-size": "8px" } },
                                [
                                  _vm._v(
                                    "\n                            Today\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("FullCalendar", {
            ref: "fullCalendar",
            staticClass: "fc-allEvents",
            attrs: { id: "fc-allEvents", options: _vm.calendarOptions },
            scopedSlots: _vm._u([
              {
                key: "eventContent",
                fn: function (arg) {
                  return [
                    _c("b", { staticClass: "soli-grey" }, [
                      _vm._v(_vm._s(arg.timeText) + " "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "subtitle-2 font-bold" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(arg.event.title) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "small",
                      {
                        staticClass: "block",
                        staticStyle: { "line-height": "11px !important" },
                      },
                      [
                        _vm._v(
                          _vm._s(`w/ ${arg.event.extendedProps.description}`)
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        _vm._s(`${arg.event.extendedProps.location.name}`)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }